import { Position, Toaster, Intent } from "@blueprintjs/core";

const SuccessNotification = Toaster.create({
	position: Position.BOTTOM_RIGHT,
	intent: Intent.SUCCESS,
	timeout: 5000
});

export default SuccessNotification;



// WEBPACK FOOTER //
// ./src/components/blueprintWrappers/SuccessNotification.js